import { useLoadingFilterScheduleStore } from './useSkeletonLoadingStore'
import { useDigitalConsultationStore } from './useDigitalConsultationStore'
import { useScheduleCancelStore } from './useScheduleCancelStore'
import { useGenericErrorStore } from './useGenericErrorStore'
import { usePreFilterStore } from './usePreFilterStore'
import { useFallbackStore } from './useFallbackStore'
import { useScheduleStore } from './useScheduleStore'
import { useLoadingStore } from './useLoadingStore'
import { useReserveStore } from './useReserveStore'
import { useStepbarStore } from './useStepbarStore'
import { useFilterStore } from './useFilterStore'
import { useChatStore } from './useChatStore'
import { useUserStore } from './useUserStore'

export const getZustandStoresSnapshot = () => ({
  digitalConsultation: useDigitalConsultationStore.getState(),
  skeletonLoading: useLoadingFilterScheduleStore.getState(),
  scheduleCancel: useScheduleCancelStore.getState(),
  genericError: useGenericErrorStore.getState(),
  preFilter: usePreFilterStore.getState(),
  fallback: useFallbackStore.getState(),
  schedule: useScheduleStore.getState(),
  loading: useLoadingStore.getState(),
  reserve: useReserveStore.getState(),
  stepbar: useStepbarStore.getState(),
  filter: useFilterStore.getState(),
  chat: useChatStore.getState(),
  user: useUserStore.getState()
})
